import { useQuery } from '@tanstack/react-query';
import useIsLoggedIn from 'src/hooks/useIsLoggedIn';
import FeatureFlags from '../models/FeatureFlags';
import useFeatureFlagsSystem from '../systems/useFeatureFlagsSystem';
import QueryKeys from './queryKeys';
import { DEFAULT_QUERY_OPTIONS } from './constants';

const useFetchFeatureFlagsQuery = () => {
	const system = useFeatureFlagsSystem();
	const isLoggedIn = useIsLoggedIn();

	return useQuery(
		QueryKeys.forFeatureFlags(),
		() => system.fetchFeatureFlags(),
		{
			...DEFAULT_QUERY_OPTIONS,
			enabled: isLoggedIn,
			select: FeatureFlags.fromJson
		}
	);
};

export default useFetchFeatureFlagsQuery;
